export default __webpack_public_path__ + "static/media/CarparkJohnsonsLondon.10e97233.JPG";